let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c2Aie")).then(() => parcelRequire('eaCYg'));